// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"724":"dc6aa560","753":"dc6aa560"}[chunkId] + ".chunk.css";
};